export default __webpack_public_path__ + "static/media/rwx_buy_img-payback.eab46648.png";